import "./Home.css";
import { useEffect, useState } from "react";
import ponteTec from "../../../src/assets/img/pontes-tecnologia.png";
import ponteDig from "../../../src/assets/img/pontes-digital.png";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import desenvolvimento from "../../../src/assets/img/desenvolvimento.png";
import aplicativo from "../../../src/assets/img/aplicativos.png";
import desing from "../../../src/assets/img/desing.png";
import sites from "../../../src/assets/img/sites.png";
import marketing from "../../../src/assets/img/marketing.png";
import planejamento from "../../../src/assets/img/planejamento.png";
import ContactInfo from "../../components/ContactInfo/ContactInfo";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import { openWhatsApp } from "../../utils/whatsapp";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import { ReactComponent as Icone } from "../../assets/img/icone-claro.svg";
import { ReactComponent as Whatsapp } from "../../assets/img/whatsapp-color-svgrepo-com.svg";
import { FaWhatsapp } from "react-icons/fa";

function Home() {
  const [service, setService] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    fetch("/mock/service.json")
      .then((res) => res.json())
      .then((result) => {
        setService(result.data);
      });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true);

    emailjs
      .sendForm(
        "service_l61k9ch",
        "template_ixz0agr",
        e.target,
        "ez2r0S9_kbS37TQqj",
      )
      .then((result) => {
        toast.success("Mensagem enviada com sucesso!");
        e.target.reset();
      })
      .catch(() => {
        toast.error("Erro ao enviar mensagem.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderForm = () => {
    return (
      <>
        {!isLoading ? (
          <>
            <div className="d-flex flex-column">
              <span className="message-title">Orçamento</span>
              <span className="message-text">
                Solicite agora o seu orçamento personalizado e descubra como
                podemos transformar sua ideia em realidade.
              </span>
            </div>
            <Form onSubmit={sendEmail} className="mt-5">
              <Row>
                <Col md={6} sm={12} className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nome"
                    name="name"
                    required
                  />
                </Col>
                <Col md={6} sm={12} className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="E-mail"
                    name="email"
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Título"
                    name="title"
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Mensagem"
                      style={{ height: "100px" }}
                      name="message"
                      required
                    ></textarea>
                    <label>Mensagem</label>
                  </div>
                </Col>
                <Col md={12} className="button-form-submit">
                  <button className="button-submit">Enviar</button>
                </Col>
              </Row>
            </Form>
          </>
        ) : (
          <div>
            <i className="bi bi-arrow-clockwise icon-arrow-clockwise spin"></i>
            <p>Enviando...</p>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="home">
      <section id="home" className="home image-main home">
        <div className="d-flex align-items-center w-100 h-100">
          <div className="container">
            <Row>
              <Col md={12}>
                <div className="hero-content d-flex flex-column">
                  <div className="hero-title">
                    <p>Da ideia</p>
                    <p>ao resultado,</p>
                  </div>

                  <h1 className="hero-emphasis">a tecnologia é a Ponte!</h1>

                  <p className="hero-description">
                    Bem-vindos ao mundo da
                    <br />
                    Pontes Tecnologia & Inovação!
                  </p>
                  <button
                    className="button-welcome pulsered mt-4"
                    onClick={() => openWhatsApp()}
                  >
                    Entre em contato
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <section id="about" className="container about">
        <div className="paragraphs">
          <h4>A Pontes Tecnologia</h4>
          <p className="text">
            Fundada em 2022 com a missão de conectar pessoas, ideias e negócios
            através da inovação. Atuamos no setor de tecnologia com foco em
            entregar soluções criativas, funcionais e sob medida para nossos
            clientes. Desde o início, buscamos ir além do convencional,
            oferecendo um atendimento próximo, escuta ativa e compromisso com
            resultados reais. Acreditamos que tecnologia bem aplicada transforma
            empresas e cria novas possibilidades. Com uma equipe apaixonada pelo
            que faz, seguimos evoluindo, aprendendo e construindo pontes para o
            futuro todos os dias.
          </p>
        </div>
      </section>
      <section id="solutions" className="home solutions">
        <Container className="our">
          <Row>
            {service.map((item, index) => (
              <Col md={4} sm={12} key={index} className="mobile-center mb-4">
                <div className="card mt-4">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h6 className="lh-1">{item.title}</h6>
                        <h6 className="last-title lh-1">{item.last}</h6>
                      </div>
                      <Icone
                        width={26}
                        color="#fff"
                        style={{ color: "#fff" }}
                      />
                    </div>
                    <span className="card-body-text">{item.text}</span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <section id="budget" className="container mb-5 mt-5 contact-space">
        <Row>
          <Col md={7} sm={12}>
            <div
              className={
                isLoading ? `contact message icon-center` : `contact message`
              }
            >
              {renderForm()}
            </div>
          </Col>
          <Col md={5} sm={12} className="info">
            <div className="d-flex flex-column">
              <h5 className="mt-5">Informações</h5>
              <span className="info-text">
                Prefere falar diretamente com a gente?
              </span>
              <span className="info-text">
                Confira nossos canais de atendimento:
              </span>
              <ContactInfo
                image={"location"}
                alt={"Local"}
                title={"Local"}
                content={["Presidente Prudente - SP"]}
              />
              <ContactInfo
                image={"phoneInfo"}
                alt={"Telefone"}
                title={"Telefone"}
                content={["(18) 99817-4736"]}
              />
              <ContactInfo
                image={"mail"}
                alt={"E-mail"}
                title={"E-mail"}
                content={["contato@pontestecnolog.com.br"]}
              />
            </div>
          </Col>
        </Row>
      </section>
      <a
        href={`https://wa.me/5518998174736?text=${encodeURIComponent("Olá, Pontes Tecnologia e Inovação.")}`}
        className="whatsapp-button pulsered"
        target="_blank"
        rel="noreferrer"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}

export default Home;
